import React from 'react';
import { OrderCtx, useOrderCtx } from './order-ctx';

export function OrderCtxProvider(props: { children: React.ReactNode }) {
  const orderCtx = useOrderCtx();

  return (
    <OrderCtx.Provider value={orderCtx}>{props.children}</OrderCtx.Provider>
  );
}
